import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopRefund(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} popSize="m"  type="pop_refund com_pay">
      <h2 className="pop_tit">환불하기</h2>
      <div className="content_container scroll">
        <section className="com_board_search">
          <article className="search full">
            <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
            <button className="com_btn gray ws s icon_search"></button>
          </article>
        </section>
        <div className="com_info">
          <div className='item'>
            <p className="tit">학생명</p>
            <p className="info">김학생103</p>
          </div>
          <span className="com_bar"></span>
          <div className='item'>
            <p className="tit">담임 </p>
            <p className="info">김교사204</p>
          </div>

          <span className="com_bar"></span>
          <div className='item'>
            <p className="tit">미입금 금액 </p>
            <p className="info">3회 ㅣ 4657,000</p>
          </div>
        </div>
        <div className="com_board_box">
          <div className="board_item">
            <div className="info">
              <input type="checkbox" name="chk" id="chk01" className="com_chk" />
              <label htmlFor="chk01"></label>
            </div>
            <div className="info">
              <span className="tit">과목</span>
              <span className="cont">국어</span>
            </div>
            <div className="info">
              <span className="tit">할인</span>
              <span className="cont">형제할인 2%</span>
            </div>
            <div className="info">
              <span className="tit">상품가격</span>
              <span className="cont">480,000</span>
            </div>
            <div className="info">
              <span className="tit">수업진행 </span>
              <span className="cont">12/16</span>
            </div>
            <div className="info">
              <span className="tit">교사 </span>
              <span className="cont">김교사103</span>
            </div>
            <div className="info">
              <span className="tit">입금된 회차 / 금액 </span>
              <span className="cont com_blue_txt">3회 / 300,000</span>
            </div>
          </div>
          <table className="com_board_list">
            <colgroup>
              <col width="100" />
              <col width="150" />
              <col width="150" />
            </colgroup>
            <thead>
              <tr>
                <th>결제 방법</th>
                <th>결제 금액 / 회차</th>
                <th>환불 가능한 금액 / 회차</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="bg_col_2">단말기</td>
                <td>78,000 / 12.0</td>
                <td>78,000 / 12.0</td>
              </tr>
              <tr>
                <td className="bg_col_2">카드</td>
                <td>45,000 / 14.2</td>
                <td>45,000 / 14.2</td>
              </tr>
              <tr>
                <td className="bg_col_2">가상계좌</td>
                <td>78,000 / 10.2</td>
                <td>78,000 / 10.2</td>
              </tr>
              <tr>
                <td className="bg_col_2">현금</td>
                <td>123,000 / 45.12</td>
                <td>123,000 / 45.12</td>
              </tr>
              <tr>
                <td className="bg_col"></td>
                <td className="bg_col td_point">798, 000 / 12.5</td>
                <td className="bg_col td_point">798, 000 / 12.5</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="com_board_box">
          <div className="board_item">
            <div className="info">
              <input type="checkbox" name="chk" id="chk02" className="com_chk" />
              <label htmlFor="chk02"></label>
            </div>
            <div className="info">
              <span className="tit">과목</span>
              <span className="cont">국어</span>
            </div>
            <div className="info">
              <span className="tit">할인</span>
              <span className="cont">형제할인 2%</span>
            </div>
            <div className="info">
              <span className="tit">상품가격</span>
              <span className="cont">480,000</span>
            </div>
            <div className="info">
              <span className="tit">수업진행 </span>
              <span className="cont">12/16</span>
            </div>
            <div className="info">
              <span className="tit">교사 </span>
              <span className="cont">김교사103</span>
            </div>
            <div className="info">
              <span className="tit">입금된 회차 / 금액 </span>
              <span className="cont com_blue_txt">3회 / 300,000</span>
            </div>
          </div>
          <table className="com_board_list">
            <colgroup>
              <col width="100" />
              <col width="150" />
              <col width="150" />
            </colgroup>
            <thead>
              <tr>
                <th>결제 방법</th>
                <th>결제 금액 / 회차</th>
                <th>환불 가능한 금액 / 회차</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="bg_col_2">단말기</td>
                <td>78,000 / 12.0</td>
                <td>78,000 / 12.0</td>
              </tr>
              <tr>
                <td className="bg_col_2">카드</td>
                <td>45,000 / 14.2</td>
                <td>45,000 / 14.2</td>
              </tr>
              <tr>
                <td className="bg_col_2">가상계좌</td>
                <td>78,000 / 10.2</td>
                <td>78,000 / 10.2</td>
              </tr>
              <tr>
                <td className="bg_col_2">현금</td>
                <td>123,000 / 45.12</td>
                <td>123,000 / 45.12</td>
              </tr>
              <tr>
                <td className="bg_col"></td>
                <td className="bg_col td_point">798, 000 / 12.5</td>
                <td className="bg_col td_point">798, 000 / 12.5</td>
              </tr>
            </tbody>
          </table>
        </div>

        <ul className="total">
          <li className="item">
            <p className="tit_field">단말기</p>
            <p className="price_field">78,000</p>
          </li>
          <li className="item">
            <p className="tit_field">카드</p>
            <p className="price_field">45,000 </p>
          </li>
          <li className="item">
            <p className="tit_field">가상계좌</p>
            <p className="price_field">78,000 </p>
          </li>
          <li className="item">
            <p className="tit_field">현금</p>
            <p className="price_field">123,000,</p>
          </li>
          <li className="item">
            <p className="tit_field">위약금</p>
            <p className="price_field">
              <input type="text" className="input com_red_txt" defaultValue="- 60,000" />
            </p>
          </li>
          <li className="item">
            <p className="tit_field">수수료</p>
            <p className="price_field">
              <input type="text" className="input com_red_txt" defaultValue="- 6,000" />
            </p>
          </li>
          <li className="item">
            <p className="tit_field com_blue_txt">최종 환불 금액</p>
            <p className="price_field com_blue_txt">798, 000</p>
          </li>
        </ul>
        <div className="detail_tit dot">환불방법 선택</div>
        <table className="com_board_list type_row">
          <colgroup>
            <col width="25%" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>카드 취소 금액</th>
              <td className="td_left">
                <input type="text" className="input ws blue" defaultValue={`15,000`} />
              </td>
            </tr>
            <tr>
              <th rowSpan={2}>무통장 입금</th>
              <td className="td_left">
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input ws blue" defaultValue={`15,000`} />
                </div>
              </td>
            </tr>
            <tr>
              <td className="td_left border_left">
                <div className="com_input_wrap flex_row account">
                  <input type="text" className="input wl" placeholder="은행명 입력" />
                  <input type="text" className="input wl" placeholder="계좌주 입력" />
                  <input type="text" className="input wl" placeholder="계좌 번호 입력" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="memo_wrap">
          <span className="com_btn lightRed s">취소</span>
          <input type="text" className="input" placeholder="환불 사유 메모 입력 (100자)" />
        </div>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">환불하기</button>
        <button className="com_btn orange xs">재검토 요청</button>
      </div>
    </Modal>
  );
}

export default PopRefund;
